const ICON_PAUSE = ({ color = "#fff", strokeWidth = 3, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 10"
    fill="none"
    {...props}
  >
    <g transform="rotate(-45 10.674 56.086) scale(1.10405)">
      <g
        style={{
          strokeWidth: 0.65502,
        }}
      >
        <path
          d="m37.5 12.507 1.367-1.367M38.638 13.644l1.367-1.367"
          style={{
            fill: "none",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 0.39243,
            stroke: color,
          }}
          transform="translate(-20.41 -4.472) scale(1.5267)"
        />
      </g>
      <circle
        cx={37.618}
        cy={-17.187}
        r={4.212}
        style={{
          fill: "none",
          paintOrder: "markers fill stroke",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.63403,
          stroke: color,
        }}
        transform="rotate(45)"
      />
    </g>
  </svg>
);

export default ICON_PAUSE;
